export const SEARCH_INPUT_WIDTH = 228;
